const PageShell = ({ children, bg = 'bg-brand-pageFill' }) => {
  return (
    <div className={`w-full ${bg}`}>
      <div className="mx-auto min-w-canvas max-w-canvas">
        {children}
      </div>
    </div>
  )
}

export default PageShell